import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component, Fragment } from "react";

import Button from "@/components/UI/Button";
import { DeleteNote } from "@/features/notes/(v2)/components/DeleteNote";
import {
  getNoteListChildren,
  getProgressNotes,
  viewNote,
  viewDraftNote,
  deleteNote,
} from "@/features/notes/(legacy)/components/ProgressNotes";
import { isAuthorized } from "@/utils/authToken";
import {
  List,
  ListBody,
  ListHeader,
  ListItem,
  ListTitleBar,
  TitleBarItem,
} from "@/components/UI/ListView";
import SearchBar from "@/components/UI/SearchBar";
import { setDynamicRouteConfiguration } from "@/redux/actions/navbar";

class ProgressNoteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      draftNoteId: "",
      isAuthorizedToCreateNotes:
        isAuthorized("provider:behavioral") || isAuthorized("provider:prescribe"),
      notes: [],
      patientId: this.props.match.params.patientId,
      search: "",
      showDeleteNote: false,
      showDraftsTab: false,
    };
  }

  componentDidMount() {
    getProgressNotes(this, false, this.state.showDraftsTab);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDraftsTab !== prevState.showDraftsTab) {
      getProgressNotes(this, false, this.state.showDraftsTab);
    }
  }

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
  }

  renderControls = () => {
    let numSessions = this.state.notes ? this.state.notes.length : 0;

    return (
      <div className="d-flex">
        <SearchBar className="mr-lg-2" onchange={this.updateSearch} value={this.state.search} />
        <Link to={`/app/patient/${this.state.patientId}/note/add?numSessions=${numSessions}`}>
          <Button
            className="Btn d-none d-lg-block Btn--pri Btn-sm ml-4 fs-16 text-center text-white"
            disabled={!this.state.isAuthorizedToCreateNotes}
          >
            Add Note
          </Button>
        </Link>
      </div>
    );
  };

  updateSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { patientDetails } = this.props.location;
    let filteredNotes = this.state.notes;

    let listItems = (
      <Fragment>
        {filteredNotes &&
          filteredNotes.map((note) => {
            let noteId = note.note_id ? note.note_id : note.id;

            return (
              <ListItem
                clickHandler={(e) => {
                  if (e.target.tagName === "IMG") {
                    return;
                  }

                  if (this.state.showDraftsTab) {
                    viewDraftNote(this, noteId, note);

                    return;
                  }

                  viewNote(this, noteId, note);
                }}
                clickOnMobile
                key={note.title}
              >
                {getNoteListChildren(
                  this,
                  note,
                  patientDetails,
                  this.state.showDraftsTab,
                  true,
                  this.props.profile,
                )}
              </ListItem>
            );
          })}
      </Fragment>
    );

    const draftActiveClass = this.state.showDraftsTab ? "active" : "";
    const allActiveClass = this.state.showDraftsTab ? "" : "active";
    const therapyCol = this.state.showDraftsTab ? "col-3" : "col-2";

    return (
      <div>
        {this.state.showDeleteNote && (
          <DeleteNote
            clickHandler={() => deleteNote(this, this.state.patientId, this.state.draftNoteId)}
            close={() => this.setState({ showDeleteNote: false })}
          />
        )}
        <ListBody>
          <ListHeader render={this.renderControls} title="Progress Note" />
          <div className="d-flex align-items-center notes-tab justify-content-sm-start tw:justify-center">
            <button
              className={`${allActiveClass} fs-14 tw:border-0 tw:bg-transparent tw:p-0 tw:font-bold`}
              onClick={() => this.setState({ showDraftsTab: false })}
              type="button"
            >
              All Notes
            </button>
            <button
              className={`${draftActiveClass} fs-14 tw:border-0 tw:bg-transparent tw:p-0 tw:font-bold`}
              onClick={() => this.setState({ showDraftsTab: true })}
              type="button"
            >
              Draft Notes
            </button>
          </div>
          <ListTitleBar>
            <TitleBarItem classes="col-2" text="Date" />
            <TitleBarItem classes="col-4" text="Therapy" />
            <TitleBarItem classes={therapyCol} text="Note Type" />
            {!this.state.showDraftsTab ? (
              <TitleBarItem classes="col-2" text="Posted By" />
            ) : (
              <TitleBarItem classes="col-1" text="" />
            )}
            <TitleBarItem classes="col-2" text="" />
          </ListTitleBar>
          <List>{this.state.notes && listItems}</List>
        </ListBody>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps, { setDynamicRouteConfiguration })(ProgressNoteList);
